import { create } from 'zustand';
export const useGroupsStore = create((set) => ({
    groups: [],
    selectedGroup: null,
    isLoading: false,
    error: null,
    setGroups: (groups) => set({ groups }),
    setSelectedGroup: (group) => set({ selectedGroup: group }),
    setLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error }),
    addGroup: (group) => set((state) => ({ groups: [...state.groups, group] })),
    updateGroup: (id, updates) => set((state) => ({
        groups: state.groups.map((g) => (g.id === id ? { ...g, ...updates } : g)),
        selectedGroup: state.selectedGroup?.id === id
            ? { ...state.selectedGroup, ...updates }
            : state.selectedGroup,
    })),
    removeGroup: (id) => set((state) => ({
        groups: state.groups.filter((g) => g.id !== id),
        selectedGroup: state.selectedGroup?.id === id ? null : state.selectedGroup,
    })),
}));
export const useGroupsFilter = create((set) => ({
    statusFilter: 'ACTIVE',
    searchQuery: '',
    setStatusFilter: (status) => set({ statusFilter: status }),
    setSearchQuery: (query) => set({ searchQuery: query }),
}));
//# sourceMappingURL=groups.store.js.map